import { render, staticRenderFns } from "./myTradeRecord.vue?vue&type=template&id=161695bf&scoped=true"
import script from "./myTradeRecord.vue?vue&type=script&lang=ts"
export * from "./myTradeRecord.vue?vue&type=script&lang=ts"
import style0 from "./myTradeRecord.vue?vue&type=style&index=0&id=161695bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161695bf",
  null
  
)

export default component.exports